import ImportLegacyOrder from "../../../components/import/importLegacyOrder.comp";
import ImportLegacyOrderProduct from "../../../components/import/importLegacyOrderProduct.comp";
import ImportLegacyUser from "../../../components/import/importLegacyUser.comp";
import Layout from "../../../components/layouts/layout.comp";
import { useTranslation } from "../../../core/translation.core";

export default function ImportProductPage() {
  const { t, msg } = useTranslation();

  return (
    <Layout title={t(msg.import.import)}>
      <ImportLegacyUser />
      <ImportLegacyOrder />
      <ImportLegacyOrderProduct />
    </Layout>
  );
}
